import React from 'react';
import { Card, Typography, Radio, Flex, theme } from 'antd';
import './nodeSelector.css';

const { useToken } = theme;
const { Title } = Typography;

interface NodeSelectorProps {
  onSelect: (type: 'conversation' | 'action') => void;
  selectedValue: string | null;
}

export const NodeSelector: React.FC<NodeSelectorProps> = ({ onSelect, selectedValue }) => {
  const { token } = useToken();

  const handleChange = (e: any) => {
    onSelect(e.target.value);
  };

  return (
    <Card style={{ width: '100%', boxShadow: token.boxShadowTertiary }}>
      <Flex vertical gap={token.padding}>
        <Title level={5} style={{ margin: 0 }}>
          Add node
        </Title>
        <Radio.Group
          buttonStyle="solid"
          style={{ width: '100%' }}
          onChange={handleChange}
          value={selectedValue}
        >
          <Flex style={{ width: '100%' }}>
            <Radio.Button value="conversation" style={{ width: '70%', textAlign: 'center' }}>
              Conversation
            </Radio.Button>
            <Radio.Button value="action" style={{ width: '50%', textAlign: 'center' }}>
              Action
            </Radio.Button>
          </Flex>
        </Radio.Group>
      </Flex>
    </Card>
  );
};
